import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { useState } from 'react';

import CatalogStatus from '@/components/CatalogComponent/components/CatalogStatus/CatalogStatus';
import CatalogInfo from '@/components/CatalogComponent/components/Info/CatalogInfo';
import useIsNarrowerThan from '@/hooks/useIsNarrowerThan';
import { useAppSelector } from '@/redux/hooks';
import { getCatalogIsDone, getCatalogIsTimedPlus } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { mergedCaterwaulAndHammerUIThemes } from '@/theme/mergedCaterwaulAndHammerUIThemes';

import { HeaderImageCluster } from './components/HeaderImageCluster/HeaderImageCluster';

type Props = {
    catalogId: number;
};

const { tabletNarrowWidthNum } = mergedCaterwaulAndHammerUIThemes.breakpoints;

export const CatalogNewBanner = ({ catalogId }: Props) => {
    const [forceIsLive, setForceIsLive] = useState(false);
    const isTimedPlus = useAppSelector((state) => getCatalogIsTimedPlus(state, catalogId));
    const isCatalogDone = useAppSelector((state) => getCatalogIsDone(state, catalogId));
    const isMobile = useIsNarrowerThan(tabletNarrowWidthNum + 1);

    return (
        <div
            className={cn(
                'mb-lg flex w-[calc(100%-40px)] max-w-[1240px] flex-col self-center border-border-secondary',
                'print:overflow-visible',
                'xsMax:mb-sm',
                isTimedPlus && 'border-t border-border-secondary'
            )}
            data-testid="catalog-new-banner"
        >
            <div className={cn('flex w-full gap-md', isMobile ? 'flex-col' : 'flex-row items-start')}>
                <HeaderImageCluster
                    catalogId={catalogId}
                    className="flex-shrink-0"
                    forceIsLive={forceIsLive}
                />

                <div className="flex min-w-0 flex-1 flex-col">
                    <CatalogInfo
                        catalogId={catalogId}
                        forceIsLive={forceIsLive}
                    />
                    {!isCatalogDone && (
                        <CatalogStatus
                            catalogId={catalogId}
                            forceIsLive={forceIsLive}
                            setForceIsLive={setForceIsLive}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
